module.exports = __webpack_public_path__ + "img/tabLeftNew.5c6e437a.png";